import { Content } from "./Content";
import { Root } from "./Root";

export const SidebarItem = Object.assign(Root, {
  Content,
});
